/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { Select, Empty } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import PAYMENT_VOUCHERS_QUERY from 'shared/graphql/query/paymentVouchers';

const { Option } = Select;

const SelectPaymentVouchersField = (props) => {
  const [voucherNumber, setVoucherNumber] = useState('');
  const { loading, error, data } = useQuery(PAYMENT_VOUCHERS_QUERY, {
    variables: {
      voucher_number: voucherNumber,
      showData: 10,
    },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <Select
      style={{
        width: '100%',
      }}
      allowClear
      notFoundContent={<Empty description="ไม่มีข้อมูล" image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      loading={loading}
      showSearch
      placeholder="ค้นหา"
      onSearch={(value) => setVoucherNumber(value)}
      onChange={(value) => props.onChange(value)}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {loading || error
        ? []
        : data.paymentVouchers.paymentVouchers.map((item) => (
            <Option key={item._id} value={item._id}>
              {item.voucher_number}
            </Option>
          ))}
    </Select>
  );
};

export default SelectPaymentVouchersField;
